import React from 'react';
import { createYandexMapLink } from '_helpers';
import addressIcon from 'components/assets/svg/link_icon.svg';
import styles from './AddressLink.module.scss';

const AddressLink = ({ city, address, withoutLink }: IProps) => (
    <>
        <span>{address}</span>
        {!withoutLink ? (
            <>
                <img className={styles.address_icon} src={addressIcon} alt="address_icon" />
                <a
                  href={createYandexMapLink(city, address)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.address_link}
                >
                    Смотреть на карте
                </a>
            </>
        ) : null}
    </>
);

export default AddressLink;

interface IProps {
    city: string;
    address: string;
    withoutLink?: boolean;
}
